import BaseMapper from '../../BaseMapper';

const MarketSpecifierMapper = (data, context) => {
    return data;
};

export default MarketSpecifierMapper;
